import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, FactoryIcon, GiftIcon, ZapIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { productImage, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const highlights = [{
  icon: BookOpenIcon,
  label: `${totalVolumes} comprehensive volumes`
}, {
  icon: GiftIcon,
  label: `${totalBonuses} exclusive bonuses`
}, {
  icon: ZapIcon,
  label: 'Instant access'
}];
export function Hero() {
  const scrollToPricing = () => document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth',
    block: 'start'
  });
  return <section className="relative isolate overflow-hidden bg-slate-900" data-id="element-107" data-mp="s9zxxe4wz0l5">
      <div className="metal-rule h-1.5 w-full" aria-hidden="true" data-id="element-108" data-mp="ncq4lneem4s1" />

      <div className="mx-auto max-w-5xl px-4 pb-14 pt-12 text-center lg:pb-20 lg:pt-16" data-id="element-109" data-mp="nekqb3xi20x6">
        <motion.p initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="inline-flex items-center gap-2 rounded-full border border-slate-300/50 bg-slate-950/60 px-4 py-2 text-xs font-bold uppercase tracking-[.14em] text-slate-200" data-id="element-110" data-mp="3cz5to748dry8">
          <FactoryIcon className="h-4 w-4" aria-hidden="true" data-id="element-111" data-mp="399bctsb4jly3" /> {productShortName}
        </motion.p>

        <motion.h1 initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        delay: 0.06,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-5 max-w-4xl text-balance text-4xl font-extrabold leading-[1.08] text-white sm:text-5xl lg:text-6xl" data-id="element-112" data-mp="3e84nlcz10yuk">
          Master your year of industrial instrumentation education
          <br data-id="element-113" data-mp="2vjzo4hpek01k" />
          <span className="metal-text" data-id="element-114" data-mp="2vjg670zr5bnj">in one afternoon.</span>
        </motion.h1>

        <motion.div initial={{
        opacity: 0,
        scale: 0.96
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.3,
        delay: 0.12,
        ease: [0.23, 1, 0.32, 1]
      }} className="mx-auto mt-9 max-w-3xl" data-id="element-115" data-mp="2hk85g3nxxvh8">
          <img src={productImage} alt="Industrial Instrumentation Teacher Ready: nine volumes and five bonus resources covering instrumentation fundamentals, measurement principles, sensors and signals, process variables, control loops, control valves, PLC and SCADA, calibration and safety, and teaching" className="mx-auto w-full drop-shadow-2xl" data-id="element-116" data-mp="s3usg13klgcq" />
        </motion.div>

        <div className="mt-9" data-id="element-117" data-mp="1622j5ra0jlfg">
          <Button onClick={scrollToPricing} arrow className="w-full sm:w-auto" data-id="element-118" data-mp="162ubmt8bd31i">
            Get your teacher ready now
          </Button>
        </div>

        <ul className="mt-7 flex flex-wrap justify-center gap-2 text-xs font-bold text-white" data-id="element-119" data-mp="x14ohzlgsq9j">
          {highlights.map(({
          icon: Icon,
          label
        }) => <li key={label} className="inline-flex items-center gap-1.5 rounded-lg border border-slate-300/20 bg-slate-950/50 px-3 py-2" data-id="element-120" data-mp="3ltqc7blwotsz">
              <Icon className="h-3.5 w-3.5 text-slate-300" aria-hidden="true" data-id="element-121" data-mp="1xa447fpd2mk5" />
              {label}
            </li>)}
        </ul>

        <p className="mt-6 text-xs font-semibold uppercase tracking-[.14em] text-slate-300" data-id="element-122" data-mp="218to7r4wn2cr">
          Created by industrial instrumentation education specialists, for educators worldwide · Updated 2026
        </p>
      </div>
    </section>;
}